import { BoxProps } from "@mui/material";
import { DividerProps, MarginProps } from "./Divider.types";

const boxProps: MarginProps[] = ["m", "mt", "mr", "mb", "ml", "my", "mx"];

export function extractBoxProps(props: DividerProps) {
  const result: BoxProps = {};
  boxProps.forEach((prop) => {
    if (props[prop] !== undefined) {
      (result as Record<string, unknown>)[prop] = props[prop];
    }
  });
  return result;
}
